module.exports = __webpack_public_path__ + "static/parade-2020-house34-6b172d1d2c6286db86ef6375a49167d3.jpg";